import { useEffect } from "react";

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}


export function useMediaHold(active) {
  useEffect(() => {
    if (!active) return;
    window.dispatchEvent(new Event("zo:media-open"));
    return () => window.dispatchEvent(new Event("zo:media-close"));
  }, [active]);
}
